export const preloadStatCardStyles = () => {
  const styles = [
    'rounded-xl shadow-lg hover:shadow-xl transition-shadow h-36 flex flex-col bg-white text-gray-900',
    'rounded-xl shadow-lg hover:shadow-xl transition-shadow h-36 flex flex-col bg-red-500 text-white',
    'cursor-pointer hover:scale-105 transform transition-transform',
    'text-xs font-medium mb-1 text-gray-600',
    'text-xs font-medium mb-1 text-white',
    'text-2xl font-bold leading-tight mr-2 text-[#1d2e61]',
    'text-2xl font-bold leading-tight mr-2 text-white',
  ];

  if (typeof document !== 'undefined') {
    const tempDiv = document.createElement('div');
    styles.forEach(style => { tempDiv.className = style; });
  }
};
